import { render, staticRenderFns } from "./AtomKnowMore.vue?vue&type=template&id=a524e88e&scoped=true"
import script from "./AtomKnowMore.vue?vue&type=script&setup=true&lang=js"
export * from "./AtomKnowMore.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a524e88e",
  null
  
)

export default component.exports